
import React, { useEffect, useState } from "react";
import { Card, CardBody, Alert, Col, Container, Form, Input, Label, Row } from "reactstrap";
import UseMoondanceApi from "../lib/api";
import { isPasswordStrong, isValidEmail } from "../lib/formatData";

import PublicFooter from '../publicWebsite/publicFooter.js';
import TopBar from '../publicWebsite/topbar.js';

const MoondanceRegister = () => {

    const moondanceApi = UseMoondanceApi();
    const [errors, setErrors] = useState({});
    const [submitResult, setSubmitResult] = useState(false);


    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [telephone, setTelephone] = useState("");
    const [company, setCompany] = useState("");
    const [address, setAddress] = useState("");
    const [postcode, setPostcode] = useState("");
    const [city, setCity] = useState("");
    const [country, setCountry] = useState("");



    const [vat, setVat] = useState("");
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [confirmPassword, setConfirmPassword] = useState();

    const [currency, setCurrency] = useState("EUR");


    function handleFirstNameChange(e) {
        setFirstName(e.target.value);
        if (e.target.value.length < 2) {
            setErrors(prevErrors => ({
                ...prevErrors,
                firstName: 'First name must be at least 2 characters long'
            }));
        } else {
            setErrors(prevErrors => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors.firstName; // Remove the 'firstName' key from errors
                return updatedErrors;
            });

        }
    }
    function handleLastNameChange(e) {
        setLastName(e.target.value);
        if (e.target.value.length < 2) {

            setErrors(prevErrors => ({
                ...prevErrors,
                lastName: 'Last name must be at least 2 characters long'
            }));

        } else {
            setErrors(prevErrors => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors.lastName;
                return updatedErrors;
            });

        }
    }
    function handleTelephoneChange(e) {
        setTelephone(e.target.value);
    }
    function handleCurrencyChange(e) {
        setCurrency(e.target.value);
    }
    function handleCompanyChange(e) {
        setErrors(false)
        setCompany(e.target.value);
    }

    function handleAddressChange(e) {
        setErrors(false)
        setAddress(e.target.value);
    }
    function handleCityChange(e) {
        setErrors(false)
        setCity(e.target.value);
    }
    function handleCountryChange(e) {
        setErrors(false)
        setCountry(e.target.value);
    }
    function handlePostcodeChange(e) {
        setErrors(false)
        setPostcode(e.target.value);
    }


    function handleVatChange(e) {
        setErrors(false)
        setVat(e.target.value);
    }
    function handleEmailChange(e) {
        setEmail(e.target.value);
        if (!isValidEmail(e.target.value)) {
            setErrors(prevErrors => ({
                ...prevErrors,
                email: 'Enter a valid email'
            }));
        } else {
            setErrors(prevErrors => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors.email;
                return updatedErrors;
            });

        }
    }

    function handlePasswordChange(e) {
        setPassword(e.target.value);
        if (!isPasswordStrong(e.target.value)) {
            setErrors(prevErrors => ({
                ...prevErrors,
                password: 'You should choose a stronger password ! (At least 8 characters, 1 uppercase, 1 lowercase, 1 number and 1 special character)'
            }));
        } else {
            setErrors(prevErrors => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors.password;
                return updatedErrors;
            });

        }



    }
    function handleConfirmPasswordChange(e) {
        setConfirmPassword(e.target.value);
        if (e.target.value != password) {
            setErrors(prevErrors => ({
                ...prevErrors,
                confirmPassword: 'Password and confirm password must be the same'
            }));
        } else {
            setErrors(prevErrors => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors.confirmPassword;
                return updatedErrors;
            });
        }
    }


    function handleSubmit() {


        let missingFields = [];

        if (!firstName) missingFields.push("First name");
        if (!lastName) missingFields.push("Last name");
        if (!email) missingFields.push("Email");
        if (!password) missingFields.push("Password");
        if (!confirmPassword) missingFields.push("Confirm Password");
        if (password !== confirmPassword) missingFields.push("Passwords do not match");
        if (!currency) missingFields.push("Reference currency");
       // if (!vat) missingFields.push("VAT number");
        //if (!company) missingFields.push("Company");
        
        if (missingFields.length > 0) {
            setErrors({ submitError: `Please correct or fill the following fields: ${missingFields.join(', ')}` });
         
        } else {
            setErrors({})
            console.log('ready to Submit')
            var requestData = {
                first_name: firstName,
                last_name: lastName,
                tel: telephone,
                currency: currency,
                company: company,
                vat: vat,
                email: email,
                password: password,
                address: address,
                postcode: postcode,
                city: city,
                country: country

            }
            moondanceApi.signup(requestData).then(response => {
                setSubmitResult(response)
                console.log(response)
            })
                .catch(error => {
                    setSubmitResult(error)
                    console.log(error)
                });
        }


    }


    return (
        <React.Fragment>

            <TopBar noMenu='true' />
            <div className='page-content public_problem' style={{height:'100%'}} >
                <Container fluid={true}>

                    <Row className="justify-content-center  ">
                        <Col xl={8} sm={12}>
                            <Card >
                                <CardBody className="p-4">
                                    {submitResult && submitResult.success && (
                                        <div>
                                            <div className="d-grid mt-4">



                                                <p><strong>Welcome to Moondance!</strong></p>

                                                <p>Thank you for registering with us.
                                                    To complete your registration, please confirm your email address by clicking the link we just sent to your inbox.</p>

                                                <p>If you don't see the email within a few minutes, please check your spam or junk folder.
                                                    Your registration will only be finalized after confirming your email.</p>

                                                <p>At Moondance, we are committed to providing a secure and seamless experience.
                                                    If you have any questions, or if you need assistance getting started, our team is available and ready to help you make the most out of your Moondance journey.</p>

                                                <p>We look forward to supporting you and growing together!</p>

                                                <p style={{ marginTop: '40px' }}>Best regards,</p>
                                                <p>The Moondance Team</p>

                                            </div>
                                        </div>
                                    )}
                                    {!submitResult.success && (

                                        <div className="py-5 ">
                                            <h2 className="text-center font-weight-bold mb-4">Welcome to Moondance!</h2>
                                            <p className="text-center text-muted mb-5">
                                                Please enter your details to create your Moondance account.
                                                You will be able to explore our platform for free with limited features.
                                            </p>

                                            <Form
                                                className="form-horizontal"
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    handleSubmit();
                                                    return false;
                                                }}
                                            >
                                                <Row className="justify-content-center">
                                                    <Col md={12}>
                                                        {/* First Name */}
                                                        <div className="mb-4">
                                                            <Label className="form-label">First name</Label>
                                                            <Input
                                                                name="first_name"
                                                                className="form-control"
                                                                placeholder="Enter your first name"
                                                                value={firstName}
                                                                onChange={handleFirstNameChange}
                                                                type="text"
                                                            />
                                                            <small className="form-text text-muted">Your first name is required to personalize your experience.</small>
                                                            {errors.firstName && (<div className="text-danger mt-2">{errors.firstName}</div>)}
                                                        </div>

                                                        {/* Last Name */}
                                                        <div className="mb-4">
                                                            <Label className="form-label">Last name</Label>
                                                            <Input
                                                                name="last_name"
                                                                className="form-control"
                                                                placeholder="Enter your last name"
                                                                value={lastName}
                                                                onChange={handleLastNameChange}
                                                                type="text"
                                                            />
                                                            <small className="form-text text-muted">Your last name is required for your account identification.</small>
                                                            {errors.lastName && (<div className="text-danger mt-2">{errors.lastName}</div>)}
                                                        </div>

                                                        {/* Telephone */}
                                                        <div className="mb-4">
                                                            <Label className="form-label">Telephone</Label>
                                                            <Input
                                                                name="telephone"
                                                                className="form-control"
                                                                placeholder="Enter your phone number (optional)"
                                                                value={telephone}
                                                                onChange={handleTelephoneChange}
                                                                type="text"
                                                            />
                                                            {errors.telephone && (<div className="text-danger mt-2">{errors.telephone}</div>)}
                                                        </div>

                                                        {/* Reference Currency */}
                                                        <div className="mb-4">
                                                            <Label className="form-label">Reference currency</Label>
                                                            <select
                                                                className="form-control"
                                                                value={currency}
                                                                onChange={handleCurrencyChange}
                                                            >
                                                                <option value="EUR">Euro</option>
                                                            </select>
                                                            <small className="form-text text-muted">Please select your preferred currency for transactions.</small>
                                                            {errors.currency && (<div className="text-danger mt-2">{errors.currency}</div>)}
                                                        </div>

                                                        {/* Company */}
                                                        <div className="mb-4">
                                                            <Label className="form-label">Company (optional)</Label>
                                                            <Input
                                                                name="company"
                                                                className="form-control"
                                                                value={company}
                                                                type="text"
                                                                placeholder="Your Company Name"
                                                                onChange={handleCompanyChange}
                                                            />
                                                            <small className="form-text text-muted">Optional: Helps associate your account with your organization.</small>
                                                            {errors.company && (<div className="text-danger mt-2">{errors.company}</div>)}
                                                        </div>

                                                        {/* Address */}
                                                        <div className="mb-4">
                                                            <Label className="form-label">Address</Label>
                                                            <Input
                                                                name="address"
                                                                className="form-control"
                                                                value={address}
                                                                type="text"
                                                                placeholder="Your Address"
                                                                onChange={handleAddressChange}
                                                            />
                                                        </div>

                                                        {/* Postcode */}
                                                        <div className="mb-4">
                                                            <Label className="form-label">Postcode</Label>
                                                            <Input
                                                                name="postcode"
                                                                className="form-control"
                                                                value={postcode}
                                                                type="text"
                                                                placeholder="Postcode"
                                                                onChange={handlePostcodeChange}
                                                            />
                                                        </div>

                                                        {/* City */}
                                                        <div className="mb-4">
                                                            <Label className="form-label">City</Label>
                                                            <Input
                                                                name="city"
                                                                className="form-control"
                                                                value={city}
                                                                type="text"
                                                                placeholder="City"
                                                                onChange={handleCityChange}
                                                            />
                                                        </div>

                                                        {/* Country */}
                                                        <div className="mb-4">
                                                            <Label className="form-label">Country</Label>
                                                            <Input
                                                                name="country"
                                                                className="form-control"
                                                                value={country}
                                                                type="text"
                                                                placeholder="Country"
                                                                onChange={handleCountryChange}
                                                            />
                                                        </div>

                                                        {/* Company VAT */}
                                                        <div className="mb-4">
                                                            <Label className="form-label">Company VAT (optional)</Label>
                                                            <Input
                                                                name="vat"
                                                                className="form-control"
                                                                value={vat}
                                                                type="text"
                                                                placeholder="Your Company VAT"
                                                                onChange={handleVatChange}
                                                            />
                                                            <small className="form-text text-muted">Optional: For business users needing invoicing under company name.</small>
                                                            {errors.vat && (<div className="text-danger mt-2">{errors.vat}</div>)}
                                                        </div>

                                                        {/* Email */}
                                                        <div className="mb-4">
                                                            <Label className="form-label">Email</Label>
                                                            <Input
                                                                name="email"
                                                                className="form-control"
                                                                placeholder="Enter email"
                                                                value={email}
                                                                onChange={handleEmailChange}
                                                                type="email"
                                                                autoComplete="off"
                                                            />
                                                            <small className="form-text text-muted">We’ll send important account information to this address.</small>
                                                            {errors.email && (<div className="text-danger mt-2">{errors.email}</div>)}
                                                        </div>

                                                        {/* Password */}
                                                        <div className="mb-4">
                                                            <Label className="form-label">Password</Label>
                                                            <Input
                                                                type="password"
                                                                className="form-control"
                                                                placeholder="Enter password"
                                                                value={password}
                                                                onChange={handlePasswordChange}
                                                                autoComplete="new-password"
                                                            />
                                                            <small className="form-text text-muted">Minimum 8 characters. Use a strong password for your security.</small>
                                                            {errors.password && (<div className="text-danger mt-2">{errors.password}</div>)}
                                                        </div>

                                                        {/* Confirm Password */}
                                                        <div className="mb-4">
                                                            <Label className="form-label">Confirm Password</Label>
                                                            <Input
                                                                type="password"
                                                                className="form-control"
                                                                placeholder="Confirm password"
                                                                value={confirmPassword}
                                                                onChange={handleConfirmPasswordChange}
                                                                autoComplete="new-password"
                                                            />
                                                            <small className="form-text text-muted">Please confirm your password to avoid typing errors.</small>
                                                            {errors.confirmPassword && (<div className="text-danger mt-2">{errors.confirmPassword}</div>)}
                                                        </div>

                                                        {/* Submit Button */}
                                                        <div className="d-grid mt-4">
                                                            <button
                                                                className="btn btn-primary btn-lg"
                                                                type="submit"
                                                            >
                                                                Register
                                                            </button>
                                                            {errors.submitError && (<div className="text-danger mt-3">{errors.submitError}</div>)}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Form>

                                        </div>


                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    );


}


export default MoondanceRegister;